import StateModel from "User/store/models/stateModel";

const state = new StateModel({
	userLogged: false,
	userName: ""
});
export { state };